@import "./helpers/scss-helper";

:host {
  display: block;
  position: relative;
  font-family: $font-family-base;
}

:host([layout="carousel"]) {
  text-align: left;
}

:host([variant="tile"]) {
  .#{$prefix}content-aggregator-item__tile {
    @include borderRadius("tile_view", "content");
  }
}

:host([align="right"]) {
  text-align: right;
  .#{$prefix}content-aggregator-item__tile--date-category {
    &.#{$prefix}on-background-image {
      position: absolute;
      top: 48px;
      right: 48px;
    }
  }
}

:host([show-abstract="false"]) {
  eon-ui-headline {
    margin-bottom: 32px;
  }
}

:host(:not[layout="carousel"]:hover) {
  @if (variable-exists(content-aggregator-drop-shadow-on-hover)) {
    box-shadow: $content-aggregator-drop-shadow-on-hover;
  }
}

eon-ui-background {
  display: flex;
  height: 100%;
}

.#{$prefix}content-aggregator-item__tile {
  display: flex;
  flex-direction: column;
  height: 100%;

  &--content-layer {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 48px 48px 44px;
    background-color: v(backgroundColor);
    word-wrap: break-word; // For EDGE 18
    word-break: break-word; // For Chrome, Safari, Firefox

    &.#{$prefix}alignment-left {
      align-items: flex-start;
      .#{$prefix}content-aggregator-item__tile--content {
        text-align: left;
      }
    }
    &.#{$prefix}alignment-center {
      align-items: center;
      .#{$prefix}content-aggregator-item__tile--content {
        text-align: center;
      }
    }
    &.#{$prefix}alignment-right {
      align-items: flex-end;
      .#{$prefix}content-aggregator-item__tile--content {
        text-align: right;
      }
    }

    .#{$prefix}content-aggregator-item__tile--headline-as-link {
      &.#{$prefix}align-left {
        align-self: flex-start;
      }

      &.#{$prefix}align-center {
        align-self: center;
      }

      &.#{$prefix}align-right {
        align-self: flex-end;
      }
    }
  }

  &--content {
    // text-align: left;
    padding-bottom: 30px;
    // for link alignment
    margin-bottom: 30px;

    @include for-size(tablet-or-larger) {
      padding-bottom: 32px;
      margin-bottom: 32px;
    }
    flex-grow: 1;
    font-size: 20px;
    font-weight: $font-weight-medium;
    color: v(contentColor);
  }

  &--date-category {
    display: flex;
    flex-direction: column;
    padding-bottom: 16px;
    eon-ui-date-event {
      --dateColor: var(--contentColor);
      --borderLeft: 1px solid var(--leftBorderColor);
    }

    .#{$prefix}content-aggregator-item__tile--category {
      font-size: 18px;
      font-weight: $font-weight-regular;
      color: v(contentColor);
    }

    &.#{$prefix}on-background-image {
      position: absolute;
      top: 48px;
      left: 48px;

      @include for-size(tablet) {
        left: 32px;
      }
      @include for-size(phone) {
        left: 24px;
      }
      eon-ui-date-event {
        --dateColor: var(--dateColorOnImage);
        --borderLeft: 1px solid var(--dateColorOnImage);
      }
      .#{$prefix}content-aggregator-item__tile--category {
        color: v(dateColorOnImage);
      }
    }
  }

  &--links {
    text-align: left;
    position: absolute;
    bottom: 44px;
  }

  &--headline-as-link {
    text-decoration: none;
    outline-style: none;

    eon-ui-headline {
      color: v(contentColor);
    }

    &:hover {
      eon-ui-headline {
        color: v(hoverColor);
      }
    }
  }
}

eon-ui-headline {
  display: inline-block;
  margin-bottom: 32px;
}

::slotted([slot="content"]) {
  font-size: 20px;
  font-weight: $font-weight-medium;
  color: v(contentColor);
}

::slotted(eon-ui-link) {
  --contentColor: var(--linkColor) !important;
  --contentHoverColor: var(--linkHoverColor) !important;
  --contentFocusColor: var(--linkHoverColor) !important;
}

::slotted(eon-ui-linkList) {
  --linklistColor: var(--linkColor);
  --linklistHoverColor: var(--linkHoverColor);
}
